import React from 'react';

const PayUPaymentView = props => {
  return <></>;
};

export default React.memo(PayUPaymentView);
